
import React, { Component, Fragment } from "react"

import $ from 'jquery'
import 'jquery-ui'
import 'jquery-ui-dist/jquery-ui';
import ReactDOM from 'react-dom';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/resizable.css';
import DropItemUI from "../../ddTxtImg/ui/DropItemUI";
import CenterElement from "../../activity/activityComponent/CenterElement";

class ClassificationDropItemUI extends DropItemUI {


    getFullDropItem = () => {
        let { dropItem, activity, quizViewer } = this.props

        return (
            <div
                style={{
                    position: "relative",
                    textAlign: "center",
                    //width: "100%"
                }}>

                {this.getDropItem()}
            </div>
        )
    }


    getDropItem = () => {

        let { dropItem, quizViewer } = this.props
        return (
            <Fragment>
                <CenterElement
                    content={dropItem.dropTxt}
                    textAlign="center"
                    fontSize="20px"
                    ref={(el) => this.itemToDrop = el}

                />

            </Fragment>
        )
    }
}

export default ClassificationDropItemUI